<template>
    <div class="home">
        <div>
            <swiper v-if="focusPictures.length > 0" :options="focusSwiperOption">
                <swiper-slide v-for="item in focusPictures">
                    <div class="demo-carousel">
                        <img v-bind:src="item" alt="">
                    </div>
                </swiper-slide>
                <div class="swiper-pagination swiper-pagination-white" slot="pagination"></div>
                <div class="swiper-button-prev swiper-button-white swiper-custom-prev" slot="button-prev"></div>
                <div class="swiper-button-next swiper-button-white swiper-custom-next" slot="button-next"></div>
            </swiper>
        </div>
        <div class="category">
            <div class="title">
                <h1>鉴赏全系列车型&nbsp;&nbsp;发现您的挚爱</h1>
                <p>总有一款东风专用车&nbsp;满足您的需求</p>
                <span>
                    <img src="../../public/img/small-logo.jpg" alt="">
                </span>
            </div>
            <Row :gutter="12" justify="center">
                <Col span="1">
                    <div class="arrows" @click="PrevProductSwiper">
                        <span v-show="isBeginning">更多车型&nbsp;</span>
                        <br>
                        <span v-bind:class="{ arrRed: isBeginning }" style="font-weight: bolder">&lt;</span>
                    </div>
                </Col>
                <Col span="22">
                    <div>
                        <swiper :options="productSwiperOption" ref="productSwiper">

                            <swiper-slide v-for="(item, index) in productCatrgory">
                                <router-link :to="{name:'product-category', query: {id: item.id, index: index}}">
                                    <img class="placeholder-img" v-bind:src="item.thumbnail" alt="">
                                    <div class="img-bottom">
                                        <p>{{item.title}}</p>
                                        <span>{{item.subTitle}}</span>
                                    </div>
                                </router-link>
                            </swiper-slide>
                        </swiper>
                    </div>
                </Col>
                <Col span="1">
                    <div class="arrows" @click="nextProductSwiper">
                        <span v-show="isEnd">更多车型&nbsp;</span>
                        <br>
                        <span v-bind:class="{ arrRed: isEnd }" style="font-weight: bolder">&gt;</span>
                    </div>
                </Col>
            </Row>
        </div>
        <div class="main">
            <div class="main-width">
                <ul>
                    <li>
                        <router-link :to="{ name: 'profile'}" tag="a">
                            <div class="main1">
                                <img src="../../public/img/icon1.png" alt="">
                                <p>公司简介</p>
                            </div>
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="{ name: 'product-list'}" tag="a">
                            <div class="main2">
                                <img src="../../public/img/icon2.png" alt="">
                                <p>产品中心</p>
                            </div>
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="{ name: 'development'}" tag="a">
                            <div class="main3">
                                <img src="../../public/img/icon3.png" alt="">
                                <p>研发制造</p>
                            </div>
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="{ name: 'contact-us'}" tag="a">
                            <div class="main4">
                                <img src="../../public/img/icon4.png" alt="">
                                <p>联系我们</p>
                            </div>
                        </router-link>
                    </li>
                </ul>
            </div>
        </div>
        <div class="news">
            <div class="title">
                <h1>新闻动态</h1>
                <p>实时掌握新闻动态</p>
                <span>
                    <img src="../../public/img/small-logo.jpg" alt="">
                </span>
            </div>
            <div class="news-width">
                <Row :gutter="0" justify="center">
                    <Col span="1">
                        <div class="arrows" @click="PrevNewsSwiper" style="position: relative; right: 24px">
                            <img src="../../public/img/arrL.png" alt="">
                        </div>
                    </Col>
                    <Col span="22">
                        <swiper :options="newsSwiperOption" ref="newsSwiper">
                            <swiper-slide v-for="item in newsAndTrends">
                                <div class="news-item">
                                    <img v-bind:src="item.thumbnail" alt="">
                                    <p>新闻&nbsp;|&nbsp;{{ item.createtime }}</p>
                                    <h3>{{ item.title }}</h3>
                                    <p class="text">{{ item.summary }}</p>
                                    <router-link v-if="item.url == ''" tag="a" :to="{ name:'news-details', query: { news_id: item.id }}">查看详情</router-link>
                                    <a v-else :href="item.url" target="_blank">
                                        <span style="color: #EE1234">查看详情</span>
                                    </a>
                                </div>
                            </swiper-slide>
                        </swiper>
                    </Col>
                    <Col span="1">
                        <div class="arrows" @click="nextNewsSwiper" style="position: relative; left: 24px">
                            <img src="../../public/img/arrR.png" alt="">
                        </div>
                    </Col>
                </Row>
            </div>
            <div class="bottom-news">
                <div class="bottom-news-width">
                    <Row :gutter="18" justify="center">
                        <Col span="8">
                            <router-link :to="{ name: 'outlet'}">
                                <img class="placeholder-img" src="../../public/img/sub-main1.jpg" alt="">
                                <div class="img-bottom">
                                    <p>营销网络</p>
                                </div>
                            </router-link>
                        </Col>
                        <Col span="8">
                            <router-link :to="{ name: 'network'}">
                                <img class="placeholder-img" src="../../public/img/sub-main2.jpg" alt="">
                                <div class="img-bottom">
                                    <p>服务网点</p>
                                </div>
                            </router-link>
                        </Col>
                        <Col span="8">
                            <router-link :to="{ name: 'overseas-market'}">
                                <img class="placeholder-img" src="../../public/img/sub-main3.jpg" alt="">
                                <div class="img-bottom">
                                    <p>海外市场</p>
                                </div>
                            </router-link>
                        </Col>
                    </Row>
                </div>
            </div>
            <div id="iCenter" style="display: none"></div>
        </div>
        <Modal v-model="notification" :mask="false" width="800" cancel-text="关闭" title="官方公告">
            <div class="notice" v-html="content"></div>
            <div slot="footer">
                <Button size="small" @click="notification=false">关闭</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
    import 'swiper/dist/css/swiper.css'
    import { swiper, swiperSlide } from 'vue-awesome-swiper'
    import * as home from '@/controller/home'

    export default {
        name: 'home',
        components: {
            swiper, swiperSlide
        },
        data() {
            return {
                notification: false,
                content: '',
                startIndex: 0,
                focusSwiperOption: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    loop: true,
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                        bulletClass: 'pagination-custom-bullet',
                        bulletActiveClass: 'pagination-custom-bullet-active'

                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                },
                productSwiperOption: {
                    slidesPerView: 3,
                    slidesPerColumn: 2,
                    spaceBetween: 20
                },
                newsSwiperOption: {
                    slidesPerView: 4,
                    spaceBetween: 30,
                    slidesPerGroup: 3
                },
                focusPictures: [], // 焦点图
                productCatrgory: [], // 产品分类
                newsAndTrends: [], // 新闻动态
                isBeginning: false,
                isEnd: true
            }
        },
        computed: {
            productSwiper() {
                return this.$refs.productSwiper.swiper
            },
            newsSwiper() {
                return this.$refs.newsSwiper.swiper
            }
        },
        mounted() {

            

            this.hasNotice()

            this.showFocusPictures()
            this.showProductCategoryList()
            this.showNewsList()

            this.area()

        },
        methods: {
            hasNotice() {
                home.hasNotice()
                    .then(result => {
                        this.notification = result.status
                        this.content = result.content
                    })
            },
            //传递位置
            area() {
                let mapObj = new AMap.Map('iCenter')
                mapObj.plugin('AMap.Geolocation', function () {
                    let geolocation = new AMap.Geolocation({
                        enableHighAccuracy: true,
                        timeout: 10000,
                    })
                    mapObj.addControl(geolocation)
                    geolocation.getCurrentPosition()
                    AMap.event.addListener(geolocation, 'complete', (data) => {

                        home.addArea({
                            province: data.addressComponent.province,
                            city: data.addressComponent.city
                        })
                    })
                    AMap.event.addListener(geolocation, 'error', (data) => {
                        if (data.info == 'FAILED') {
                            this.$Message.error('获取您的位置信息失败')
                        }
                    })
                })
            },
            // 显示首页的焦点图
            showFocusPictures() {
                home.fetchFocusPictures()
                    .then(result => {
                        this.focusPictures = result
                    })
            },
            // 显示首页的产品分类列表
            showProductCategoryList() {
                home.fetchProductCategoryList()
                    .then(result => {
                        this.productCatrgory = result
                    })
            },
            // 显示首页的新闻动态列表
            showNewsList() {
                home.fetchNews()
                    .then(result => {
                        this.newsAndTrends = result
                    })
            },
            //产品分类上下一张图
            PrevProductSwiper() {
                this.productSwiper.slidePrev()
                this.changeMoreStatus()

            },
            nextProductSwiper() {
                this.productSwiper.slideNext()
                this.changeMoreStatus()
            },
            changeMoreStatus() {
                if(this.productSwiper.isBeginning) {
                    this.isBeginning = false
                }else {
                    this.isBeginning = true
                }

                if(this.productSwiper.isEnd) {
                    this.isEnd = false
                }else {
                    this.isEnd = true
                }
            },
            //新闻上下切换
            PrevNewsSwiper() {
                this.newsSwiper.slidePrev()
            },
            nextNewsSwiper() {
                this.newsSwiper.slideNext()
            }
        }
    }
</script>

<style scoped lang="stylus">
    $width = 1000px
    .notice
        max-height 400px
        overflow-y auto
    .notice >>> img
        max-width 100%
    .swiper-custom-prev
        left 50px
    .swiper-custom-next
        right 50px
    .demo-carousel
        margin 0 auto
        width 100%
        height 560px
        background-color ghostwhite
        img
            display block
            width 100%
            height 100%
            background-color dimgrey
    .title
        padding 10px
        height 120px
        margin-bottom 10px
        h1
            color red
        p
            color gray
        span
            display block
            position relative
            bottom 20px
            margin 0px auto
            border-bottom 1px solid gainsboro
            width 200px
            img
                position relative
                top 20px
    .category
        margin 42px auto
        width 1090px
        .arrows
            width 24px
            padding 220px 3px
            background-color gainsboro
            height 506px
            cursor pointer
            margin 0 auto
            background-image url("../../public/img/arr-bg.gif")
            background-repeat repeat
            color darkgray
            .arrRed
                color red
        .placeholder-img
            display block
            width 100%
            height 180px
            background-color #fff
        .img-bottom
            height 51px
            padding 8px 4px
            margin-bottom 24px
            background-color #F5F5F5
            p
                font-weight bold
                font-size 14px
                color dimgrey
            span
                color gray
                font-size 10px
    .main
        background-color gainsboro
        background-image url("../../public/img/mainbg.jpg")
        background-size cover
        margin 100px 0px 60px
        width 100%
        height 400px
        .main-width
            width $width
            margin 0 auto
            height 100%
            ul
                width 100%
                height 100%
                display table
                table-layout fixed
                margin 0
                padding 0
                &:hover
                    li
                        width 35%
                li
                    display table-cell
                    vertical-align bottom
                    position relative
                    width 50%
                    background-repeat no-repeat
                    background-position center center
                    transition all 500ms ease
                    height 100%
                    &:hover
                        width 58%
                    a
                        display block
                        width 100%
                        position relative
                        z-index 3
                        vertical-align bottom
                        box-sizing border-box
                        text-decoration none
                        transition all 200ms ease
                        height 100%
                        div
                            height 100%
                            background-position center center
                            position relative
                            padding-top 200px
                            img
                                width 48px
                            p
                                font-size 18px
                                font-weight bold
                                color white
                        .main1
                            bottom 25px
                            background-image url("../../public/img/main1.jpg")
                        .main2
                            bottom 10px
                            background-image url("../../public/img/main2.jpg")
                        .main3
                            bottom 25px
                            background-image url("../../public/img/main3.jpg")
                        .main4
                            bottom 10px
                            background-image url("../../public/img/main4.jpg")
    .news
        .news-width
            width 1084px
            margin 0 auto
            .arrows
                cursor pointer
                height 320px
                padding-top 100px
                img
                    width 80%
            .news-item
                height 320px
                background-color white
                text-align left
                img
                    width 100%
                    display block
                    height 180px
                h3
                    color black
                p
                    color gray
                .text
                    display block
                    height 54px
                a
                    color red
        .bottom-news
            background-color gainsboro
            margin-top 180px
            height 180px
            .bottom-news-width
                position relative
                bottom 80px
                width $width
                margin 0 auto
                .placeholder-img
                    display block
                    height 180px
                    background-color gray
                .img-bottom
                    padding 10px
                    p
                        font-size 14px
                        font-weight bold
                        color white
</style>
